export default __webpack_public_path__ + "static/media/modal-logo.44f17eea.svg";